import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "upload-header py-1",
  id: "visit-attachments-hc"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "d-inline mr-auto" }, "Attachments", -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, " Click Add Attachment to upload files associated with this task. Once uploaded, files will appear below ", -1 /* HOISTED */)
const _hoisted_5 = { class: "" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "upload-filters" }
const _hoisted_8 = { class: "doc-body" }
const _hoisted_9 = { class: "table table-responsive-md borderless" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "File"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-8" })
], -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-6" })
], -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-4" })
], -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-file me-1 fa-lg" }, null, -1 /* HOISTED */)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "d-flex gap-2 justify-content-center align-items-center"
}
const _hoisted_20 = {
  key: 0,
  class: "d-none"
}
const _hoisted_21 = {
  key: 1,
  class: "form-check align-items-center"
}
const _hoisted_22 = ["name", "id", "value", "checked"]
const _hoisted_23 = {
  class: "m-0 ms-1",
  for: "file_single_0716f4a9-0c20-40a6-8956-83e50d91ee3c"
}
const _hoisted_24 = {
  key: 0,
  colspan: "4"
}
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = ["onClick", "disabled"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye" }, null, -1 /* HOISTED */)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "text-default"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableEmpty = _resolveComponent("TableEmpty")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.addPatientDocumentsPermission && !_ctx.loadingAttachments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAddAttachment && _ctx.toggleAddAttachment(...args))),
                class: "btn btn-primary border border-primary",
                disabled: _ctx.isPlanner
              }, " Add Attachment ", 8 /* PROPS */, _hoisted_6)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "document-filters")
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("table", _hoisted_9, [
        _hoisted_10,
        (_ctx.taskAttchments?.length == 0 && !_ctx.loadingAttachments)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
              _createVNode(_component_TableEmpty, {
                "col-span": 5,
                component: "attachments",
                "secondary-message": "No Attachments to Display"
              })
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
              (_ctx.loadingAttachments)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, _hoisted_16))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              (!_ctx.loadingAttachments)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.taskAttchments, (document) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: document.AssetId
                    }, [
                      _createElementVNode("td", null, [
                        _hoisted_17,
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.downloadDocuments(document))
                        }, _toDisplayString(document.FileName), 9 /* TEXT, PROPS */, _hoisted_18)
                      ]),
                      _createElementVNode("td", null, [
                        (document.UploadedDocumentationType !== _ctx.uploadedDocumentationTypeEnum.None)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadedDocumentationType, ([, information]) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: information.name
                                }, [
                                  (information.value === _ctx.uploadedDocumentationTypeEnum.None)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _createElementVNode("input", {
                                          type: "radio",
                                          name: `uploadedDocumentationType_${document.AssetId}`,
                                          id: `uploadedDocumentationType_${document.AssetId}_${information.name}`,
                                          disabled: "",
                                          value: information.value,
                                          checked: document.UploadedDocumentationType === information.value
                                        }, null, 8 /* PROPS */, _hoisted_22),
                                        _createElementVNode("label", _hoisted_23, _toDisplayString(information.longDescription), 1 /* TEXT */)
                                      ]))
                                ], 64 /* STABLE_FRAGMENT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createCommentVNode(" DELETE "),
                      (_ctx.attachmentToDelete === document?.AssetId)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                            _createVNode(_component_TablePrompt, {
                              "ok-text": "Delete",
                              cancelText: "Cancel",
                              operation: " ",
                              name: "Delete",
                              includeYes: true,
                              isInProgress: _ctx.isDeleteInProgress,
                              ok: _ctx.deleteSelectedDocument,
                              cancel: _ctx.cancelDeleteAttachment
                            }, null, 8 /* PROPS */, ["isInProgress", "ok", "cancel"])
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createCommentVNode(" ACTIONS  "),
                            _createElementVNode("td", _hoisted_25, [
                              (_ctx.editPatientDocumentsPermission || _ctx.deletePatientDocumentsPermission)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.deletePatientDocumentsPermission)
                                      ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "btn table-btn btn-outline-danger",
                                          onClick: ($event: any) => (_ctx.requestDelete(document?.AssetId)),
                                          disabled: _ctx.isPlanner
                                        }, _hoisted_28, 8 /* PROPS */, _hoisted_26)), [
                                          [_directive_tooltip, { title: 'Delete' }]
                                        ])
                                      : _createCommentVNode("v-if", true),
                                    _withDirectives((_openBlock(), _createElementBlock("button", {
                                      type: "button",
                                      class: "btn table-btn btn-outline-info au-target",
                                      onClick: ($event: any) => (_ctx.openSelectedDocument(document))
                                    }, _hoisted_31, 8 /* PROPS */, _hoisted_29)), [
                                      [_directive_tooltip, { title: 'View' }]
                                    ])
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock("i", _hoisted_32, "No Actions"))
                            ])
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]))
      ])
    ])
  ]))
}